<template>
    <v-container grid-list-lg>
        <image-category-promo />
    </v-container>
</template>

<script>
    import ImageCategoryPromo from "../components/HomePage/ImageCategoryPromo";

    export default {
        name: 'Homepage',
        components: {
            ImageCategoryPromo
        }
    }
</script>
